import React from "react";
import { SelectedProductContainer } from "./style";
import NumberFormat from "components/numberFormat";
import { FiEdit3 } from "react-icons/fi";

const SelectedProduct = ({ product, selectedOptions, goTo, showPic }) => {
  const selectedOptionsView = () => {
    return Object.keys(selectedOptions).map((key, index) => {
      return (
        <span className="option" key={index}>
          {selectedOptions[key].title}
        </span>
      );
    });
  };
  const lastPrice = () => {
    let firstPrice = product.price;
    let plus = 0;
    Object.keys(selectedOptions).forEach((key) => {
      plus = plus + selectedOptions[key].added_price;
    });
    let sum = firstPrice + plus;
    return {
      total: sum,
      plus: plus,
    };
  };
  return (
    <SelectedProductContainer>
      {goTo ? <FiEdit3 className="edit-icon" onClick={goTo} /> : ""}
      <div className="image">
        <img src={`./images/${showPic}.jpg`} alt="product" />
      </div>
      <div className="content">
        <div className="title-area">
          <h5>{product?.item.title}</h5>

          <span className="number">شماره {product?.reference}</span>
        </div>
        <div className="labels">
          <span className="label">{product?.title}</span>
          <span className="label">{product?.price_note}</span>
        </div>
        <div
          className="description"
          dangerouslySetInnerHTML={{ __html: product?.item.description }}
        />
        <div className="date">{product?.delivery_note}</div>
      </div>
      <div className="price">
        {selectedOptionsView()}
        <span>
          مبلغ قابل پرداخت: <NumberFormat value={lastPrice()["total"]} />
        </span>
        {lastPrice()["plus"] ? (
          <span>
            اختلاف قیمت: <NumberFormat value={lastPrice()["plus"]} />
          </span>
        ) : null}
      </div>
    </SelectedProductContainer>
  );
};
export default SelectedProduct;
